import axios from "../general/HttpClient";

export const ListImages = () => {
    return axios.get("/api/images");
};

export interface SDImage {
    id: number;
    imageType: SDImageType;
    prompt: string;
    info: string;
    content: string;
    processed: boolean;
    parentID: number | null;
    parent: SDImage;
}

export enum SDImageType {
    Card = 0,
    ThemeBorder = 1,
    Faction = 2,
    Campaign = 3,
    Theme = 4,
}
